import React from 'react';
import StatsTable from './StatsTable';
import StatsByServer from './StatsByServer';

class Stats extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {stats, version} = this.props;

    return (
      <div className="results__stats">
        <StatsTable stats={stats} comparison={!stats.on_netlify.value} />
        <StatsByServer stats={stats} />
      </div>
    );
  }
}

Stats.propTypes = {
  stats: React.PropTypes.object,
  onNetlify: React.PropTypes.bool,
  version: React.PropTypes.string
};

export default Stats;



// WEBPACK FOOTER //
// ./src/components/results/Stats.js